import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import './styles/App.css';
import Homepage from './components/Homepage';
import Dashboard from './components/Dashboard';
import WelcomePage from './components/WelcomePage';
import SurveyPage from './components/SurveyPage';
import ActivitiesPage from './components/ActivitiesPage';
import ChallengeCompletePage from './components/ChallengeCompletePage';
import { getActivitiesUrl, getPostSurveyUrl, getPreSurveyUrl } from './config';
import { trackScreenViewed } from './tracking';
// Event configuration - in future this will come from backend
const EVENT_SLUG = 'hof-spring-2026';
const App = () => {
    const [currentView, setCurrentView] = useState('homepage');
    const [activeNav, setActiveNav] = useState('welcome');
    // Store join code and session info for future use
    const [joinCode, setJoinCode] = useState('');
    const [sessionId, setSessionId] = useState('');
    const [preSurveyComplete, setPreSurveyComplete] = useState(false);
    const [completedActivityTitle, setCompletedActivityTitle] = useState('');
    const lastTrackedScreenRef = useRef(null);
    useEffect(() => {
        const nextKey = trackScreenViewed({
            currentView,
            activeNav,
            joinCode,
            completedActivityTitle: completedActivityTitle || undefined,
        }, lastTrackedScreenRef.current);
        if (nextKey) {
            lastTrackedScreenRef.current = nextKey;
        }
    }, [activeNav, completedActivityTitle, currentView, joinCode]);
    const handleJoinSuccess = (code, newSessionId) => {
        setJoinCode(code);
        setSessionId(newSessionId);
        setCurrentView('dashboard');
    };
    const handleNavChange = (nav) => {
        setActiveNav(nav);
    };
    const handleGetStarted = () => {
        // Navigate to pre-survey when user clicks "Get Started" on welcome page
        setActiveNav('pre-survey');
    };
    const handlePreSurveyComplete = () => {
        // Mark pre-survey as complete and navigate to activities
        setPreSurveyComplete(true);
        setActiveNav('activities');
    };
    const handleActivitiesComplete = () => {
        // Navigate to post-survey after completing activities
        setActiveNav('post-survey');
    };
    const handlePostSurveyComplete = () => {
        // Show the challenge complete page
        setCurrentView('complete');
    };
    const handleChallengeClose = () => {
        // Reset to homepage after completing the challenge
        setCurrentView('homepage');
        setActiveNav('welcome');
        setPreSurveyComplete(false);
        setJoinCode('');
        setSessionId('');
        setCompletedActivityTitle('');
    };
    // Render dashboard content based on active nav
    const renderDashboardContent = () => {
        switch (activeNav) {
            case 'welcome':
                return (_jsx(WelcomePage, { onGetStarted: handleGetStarted, joinCode: joinCode || undefined }));
            case 'pre-survey':
                return (_jsx(SurveyPage, { surveyUrl: getPreSurveyUrl(), surveyType: "pre", sessionId: sessionId, eventSlug: EVENT_SLUG, joinCode: joinCode, onComplete: handlePreSurveyComplete }));
            case 'activities':
                return (_jsx(ActivitiesPage, { activitiesUrl: getActivitiesUrl(), onComplete: handleActivitiesComplete, joinCode: joinCode || undefined, sessionId: sessionId, eventSlug: EVENT_SLUG, onActivityStart: setCompletedActivityTitle }));
            case 'post-survey':
                return (_jsx(SurveyPage, { surveyUrl: getPostSurveyUrl(), surveyType: "post", sessionId: sessionId, eventSlug: EVENT_SLUG, joinCode: joinCode, onComplete: handlePostSurveyComplete }));
            default:
                return (_jsx(WelcomePage, { onGetStarted: handleGetStarted, joinCode: joinCode || undefined }));
        }
    };
    if (currentView === 'complete') {
        return (_jsx(ChallengeCompletePage, { onClose: handleChallengeClose }));
    }
    if (currentView === 'dashboard') {
        return (_jsx(Dashboard, { activeNav: activeNav, onNavChange: handleNavChange, preSurveyComplete: preSurveyComplete, children: renderDashboardContent() }));
    }
    return _jsx(Homepage, { onJoinSuccess: handleJoinSuccess });
};
export default App;
